import { css, useTheme } from '@emotion/react';

const useStyle = () => {
  const theme = useTheme();

  const container = css`
    --display: none;
    display: var(--display);
    transition: all 0.3s ease-in-out;
    width: 100%;
    margin: 0 auto;
    position: absolute;
    top: 61px;
  `;

  const wrapper = css`
    max-width: 1240px;
    margin: 0 auto;
    width: 100%;
    padding: 35px 87px;
    position: relative;
  `;

  const active = css`
    --display: flex;
  `;

  const defaultWrapperStyle = css`
    background-color: white;
    box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.15);
  `;

  return {
    container,
    wrapper,
    active,
    defaultWrapperStyle,
  };
};

export default useStyle;
